import { jsx as C } from "react/jsx-runtime";
function o(t) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ C("path", { d: "M0 8.33333C0 3.73096 3.73096 0 8.33333 0C10.6353 0 12.7204 0.934716 14.2277 2.44303C14.7606 2.97633 15.3318 3.63492 15.8333 4.24479V1.66667C15.8333 1.20643 16.2064 0.833333 16.6667 0.833333C17.1269 0.833333 17.5 1.20643 17.5 1.66667V6.66667C17.5 7.1269 17.1269 7.5 16.6667 7.5H11.6667C11.2064 7.5 10.8333 7.1269 10.8333 6.66667C10.8333 6.20643 11.2064 5.83333 11.6667 5.83333H14.9731C14.3964 5.10952 13.6806 4.25231 13.0493 3.62061C11.8418 2.41231 10.1753 1.66667 8.33333 1.66667C4.65144 1.66667 1.66667 4.65144 1.66667 8.33333C1.66667 12.0152 4.65144 15 8.33333 15C11.3714 15 13.937 12.967 14.7396 10.1855C14.8672 9.74341 15.3293 9.48829 15.7715 9.61589C16.2136 9.74357 16.4687 10.2057 16.3411 10.6478C15.3382 14.1235 12.1337 16.6667 8.33333 16.6667C3.73096 16.6667 0 12.9357 0 8.33333Z" })
    }
  );
}
export {
  o as ReloadIcon
};
